// extracted by css-extract-rspack-plugin
export default {"gap_1":"ShortcutEditingHeader-module__gap_1__4fiR8","gap_2":"ShortcutEditingHeader-module__gap_2__wEU4V"};